export default __webpack_public_path__ + "static/media/card-blog5.c840a3d5.jpg";